import { observable, action, makeObservable } from "mobx"
import { getMissPartCarListPage } from 'requests/entranceInspection'

class weighingRecord {
    constructor() {
        makeObservable(this)
    }
    // 待认定
    @observable pendingList = []
    @observable pendingPageModal = {
        page: 1,
        pageSize: 10,
        total: 0
    }
    @observable pendingCondition = {
        "boutiqueCar": null,
		"carBrand": "",
		"hasResponsibility": 0,
		"licensePlate": "",
		"responsibilityIdentifierName": "",
		"responsibilityTime": "",
		"warehouseId": ""
    }

    // 已认定
    @observable acceptList = []
    @observable acceptPageModal = {
        page: 1,
        pageSize: 10,
        total: 0
    }
    @observable acceptCondition = {
        "boutiqueCar": null,
		"carBrand": "",
		"hasResponsibility": 1,
		"licensePlate": "",
		"responsibilityIdentifierName": "",
		"responsibilityTime": "",
		"warehouseId": ""
    }

    // 待认定
    @action getPendingList(pageModal, condition) {
        const { page, pageSize } = pageModal || this.pendingPageModal

        getMissPartCarListPage({
            pageNum: page,
            pageSize,
            condition: condition || this.pendingCondition
        }).then(resp => {
            if (resp && !resp.code) {
                this.pendingList = resp.data ? resp.data : [];
                this.pendingPageModal = resp.pageModal
            }
        })
    }

    // 已认定
    @action getAcceptList(pageModal, condition) {
        const { page, pageSize } = pageModal || this.acceptPageModal

        getMissPartCarListPage({
            pageNum: page,
            pageSize,
            condition: condition || this.acceptCondition
        }).then(resp => {
            if (resp && !resp.code) {
                this.acceptList = resp.data ? resp.data : [];
                this.acceptPageModal = resp.pageModal
            }
        })
    }

    //  重置或查询 修改condition
    @action resetForm = (condition, key) => {
        if (key === 1) {
            this.pendingCondition = {
                ...condition,
                hasResponsibility: 0
            }
            this.pendingPageModal = {
                page: 1,
                pageSize: 10
            }
        }
        if (key === 2) {
            this.acceptCondition = {
                ...condition,
                hasResponsibility: 1
            }
            this.acceptPageModal = {
                page: 1,
                pageSize: 10
            }
        }
    }
}

export default weighingRecord